import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import checkImg from './img/check.png';

class InputMail extends Component {
  constructor() {
    super();
    this.state = {
      // mailCheck: false
    };
  }
  componentDidUpdate() {
    const patt = new RegExp(/^.+[@]\w+[.]\w+$/g);
    if (patt.test(this.props.Value)) {
      this.props.mailIsOk(true);
    } else {
      this.props.mailIsOk(false);
    }
  }
  mailVerification = (e) => {
    this.props.onChange(e);
  }

  render() {
    return (
      <div className="admin-InputMailConteiner">
        <span className="admin-InputMailName">EMAIL ADDRESS</span>
        <input
          value={this.props.Value}
          className="admin-InputMail"
          placeholder="somebody@gmail.com"
          onChange={this.mailVerification}
        />
        { this.props.cheked === true && <img className="checkImg" src={checkImg} alt="checkImg" />}
      </div>
    );
  }
}
InputMail.defaultProps = {
  onChange: () => {},
  mailIsOk: () => {},
  Value: '',
  cheked: false
};

InputMail.propTypes = {
  Value: PropTypes.string,
  onChange: PropTypes.func,
  mailIsOk: PropTypes.func,
  cheked: PropTypes.bool

};
export default InputMail;



// WEBPACK FOOTER //
// ./src/pages/LoginAdmin/commponents/inputMail/index.js